import { analytics, AnalyticsTrackAction, AnalyticsTrackSubject } from '@atlassian/temp-analytics';
import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/1/atlassian-accounts' }, ServiceProxyMap.ANS);

export async function closeAccount(atlassianAccountId: string): Promise<null> {
  await client.delete(`/${atlassianAccountId}`);
  return null;
}

export async function obfuscateAccount(atlassianAccountId: string): Promise<void> {
  await client.put(`/${atlassianAccountId}/obfuscate`);
}

export async function fetchEmailVerificationLink(email: string): Promise<string> {
  const result = await client.get(`/${email}/email-verification-link`);

  analytics.sendTrackEvent({
    action: AnalyticsTrackAction.SENT,
    actionSubject: AnalyticsTrackSubject.VERIFY_USER,
  });

  return result.data;
}

export async function fetchResetPasswordLink(email: string): Promise<string> {
  const result = await client.get(`/${email}/reset-password-link`);

  analytics.sendTrackEvent({
    action: AnalyticsTrackAction.SENT,
    actionSubject: AnalyticsTrackSubject.RESET_PASSWORD,
  });

  return result.data;
}
